import { initializeIcons, Stack } from '@fluentui/react';
import "@fontsource/poppins"; // Defaults to weight 400.
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./components/application/app";
import CrudTester from './components/crudtester';
import CRUDTable from './components/shared/crudTable';
import SlideShow from './components/slideShow.tsx';
import { ICRUDProps } from './data/sql';
import './index.css';
import Course from './pages/course';
import Home from './pages/home';
import NotFound from './pages/notfound';
import Settings from './pages/settings';
import { AccreditationProvider } from './providers/accreditationprovider';
import { AccreditationRulesProvider } from './providers/accreditationrulesprovider';
import { AuthenticationProvider } from './providers/authenticationprovider';
import { CoursesProvider } from './providers/coursesprovider';
import { SemesterProvider } from './providers/semesterprovider';
initializeIcons(
  'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
);

const settingRouteProps: ICRUDProps[] = [
  {
    routePath: "coursePrefixes",
    apiPaths: {
      getItems: "getCoursePrefixes",
      deleteItem: "deleteCoursePrefix",
      addOrUpdateItem: "updateCoursePrefix"
    },
    idField: "CoursePrefixId",
    columns: [{
      key: "Prefix",
      name: "Prefix",
      fieldName: "Prefix",
      minWidth: 200
    },
    {
      key: "Description",
      name: "Description",
      fieldName: "Description",
      minWidth: 600
    }], friendlyName: 'Course Prefix'
  },
  {
    routePath: "accreditors",
    apiPaths: {
      getItems: "getListOfAccreditors",
      deleteItem: "deleteAccreditor",
      addOrUpdateItem: "updateAccreditor"
    },
    idField: "AccreditorId",
    columns: [{
      key: "AccreditorName",
      name: "Name",
      fieldName: "AccreditorName",
      minWidth: 200
    },
    {
      key: "Description",
      name: "Description",
      fieldName: "Description",
      minWidth: 600
    },
    {
      key: "IsActive",
      name: "Is Active",
      fieldName: "IsActive",
      data: {
        type: "Toggle"
      },
      minWidth: 80,
      onRender: (item) => item.IsActive ? "Yes" : "No"
    },
    {
      key: "ShouldAnonymizeStudents",
      name: "Anonymize Students",
      fieldName: "ShouldAnonymizeStudents",
      data: {
        type: "Toggle"
      },
      minWidth: 150,
      onRender: (item) => item.ShouldAnonymizeStudents ? "Yes" : "No"
    }],
    friendlyName: 'Accreditor'
  },
  {
    routePath: "ruleDefinitions",
    apiPaths: {
      getItems: "getListOfAccreditorFieldDefinitions",
      deleteItem: "deleteAccreditationRuleDefinition",
      addOrUpdateItem: "updateAccreditationRule"
    },
    idField: "AccreditationFieldDefinitionId",
    columns: [],
    friendlyName: 'Accreditor Rule Setting',
    buildColumns: true,
    columnsToFilter: ["AccreditationFieldDefinitionId", "CompetencyColor"],
    additionalColumns: [{
      key: "CompetencyColor",
      name: "Color",
      data: { type: "ColorPicker" },
      minWidth: 80,
      onRender: (item) => {
        return <Stack horizontal tokens={{ childrenGap: 10 }}><span>{item.CompetencyColor}</span><div style={{ height: 20, width: 20, backgroundColor: item.CompetencyColor }}></div></Stack>
      }
    },
    ]
  },
  {
    routePath: "criteriaDefinitions",
    apiPaths: {
      getItems: "getListOfCriteriaDefinitions",
      deleteItem: "deleteCriteriaDefinition",
      addOrUpdateItem: "updateCriteriaDefinition"
    },
    idField: "CriteriaDefinitionId",
    columns: [],
    friendlyName: 'Criteria Definition',
    buildColumns: true,
    columnsToFilter: ["CriteriaDefinitionId", "CriteriaColor"],
    additionalColumns: [{
      key: "CriteriaColor",
      name: "Color",
      data: { type: "ColorPicker" },
      minWidth: 80,
      onRender: (item) => {
        return <Stack horizontal tokens={{ childrenGap: 10 }}><span>{item.CriteriaColor}</span><div style={{ height: 20, width: 20, backgroundColor: item.CriteriaColor }}></div></Stack>
      }
    },
    ]
  }];

ReactDOM.render(
  <React.StrictMode>
    <AuthenticationProvider>
      <SemesterProvider>
        <AccreditationRulesProvider>
          <CoursesProvider>
            <AccreditationProvider>
              <BrowserRouter>
                <Routes>
                  <Route element={<App />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Home />} />
                    <Route path="/settings" element={<Settings />}>
                      <Route path="" element={<div>Choose a setting from the navigation to continue...</div>} />
                      {/*<Route path="criteriaDefinitions" element={<AccreditorCriteriaDefinitions />} />*/}
                      {settingRouteProps.map(settingRouteProp => {
                        return <Route key={`route-${settingRouteProp.routePath}`} path={settingRouteProp.routePath} element={<CRUDTable props={settingRouteProp} />} />
                      })}
                      <Route element={<NotFound />} />
                    </Route>
                    <Route path="/crudtester" element={<CrudTester />} />
                    <Route path="/courses/:year/:semester/:id" element={<Course />} />
                    <Route path="/courses/:year/:semester/:id/canvassyllabus" element={<Course syllabus={true} />} />                    
                    <Route path="/courses/:year/:semester/:id/assignments/:assignmentName" element={<Course />} />
                    <Route path="/courses/:year/:semester/:id/accreditorCourseSettings" element={<Course accreditorCourseSettings={true} />} />
                    <Route path="/courses/:year/:semester/:id/:supplementalFolderName" element={<Course supplementalFolder={true} />} />
                    <Route element={<NotFound />} />
                  </Route>
                </Routes>
              </BrowserRouter>
            </AccreditationProvider>
          </CoursesProvider>
        </AccreditationRulesProvider>
      </SemesterProvider>
    </AuthenticationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);